// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Ez8OKYxg3QT4lpvzL9gN_ primaryColor"};